// ============================================
// STORE DE UI (Pinia) — tema claro/oscuro
// ============================================
// Aplica el tema en <html> con dos atributos:
//   - data-theme       → tokens propios del design system (--hb-*)
//   - data-bs-theme    → componentes de Bootstrap 5.3 (dropdowns, modales, tablas)
// Persiste la preferencia en localStorage y, si no hay, respeta el SO.

import { defineStore } from 'pinia';

const STORAGE_KEY = 'hb:theme';

function resolveInitialTheme() {
  const saved = localStorage.getItem(STORAGE_KEY);
  if (saved === 'light' || saved === 'dark') return saved;
  const prefiereOscuro = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
  return prefiereOscuro ? 'dark' : 'light';
}

function applyTheme(theme) {
  const html = document.documentElement;
  html.setAttribute('data-theme', theme);
  html.setAttribute('data-bs-theme', theme);
}

export const useUiStore = defineStore('ui', {
  state: () => ({
    theme: 'light'
  }),

  getters: {
    esOscuro: (state) => state.theme === 'dark'
  },

  actions: {
    /** Lee la preferencia guardada/del SO y la aplica. Llamar al arrancar. */
    initTheme() {
      this.theme = resolveInitialTheme();
      applyTheme(this.theme);
    },

    setTheme(theme) {
      this.theme = theme === 'dark' ? 'dark' : 'light';
      localStorage.setItem(STORAGE_KEY, this.theme);
      // Activa transición suave solo al cambiar (no en la carga inicial)
      document.documentElement.classList.add('hb-theming');
      applyTheme(this.theme);
      window.setTimeout(() => document.documentElement.classList.remove('hb-theming'), 250);
    },

    toggleTheme() {
      this.setTheme(this.theme === 'dark' ? 'light' : 'dark');
    }
  }
});
